// extracted by mini-css-extract-plugin
export default {"container":"ConfirmDeleteImagePopup_container__Nikp9","title":"ConfirmDeleteImagePopup_title__z4A5G","buttonsContainer":"ConfirmDeleteImagePopup_buttonsContainer__woi+e"};